import Swiper from "swiper";

import "jquery-modal";
import { Navigation, Pagination } from "swiper/modules";
import { createPopper } from "@popperjs/core";
import "../../../../src/js/tos.js";
import { redirectToThanksPage } from "../components/newForms.js";

const HG_MAX = 1200;
const LG_MAX = 993;
const MD_MAX = 768;
const SM_MAX = 600;
const XS_MAX = 470;

$(() => {
    // studiedSwiper();
    studiedSwiper2();
    reviewSwiper();
    questionBlocks();
    questionBlocksSecond();
    showVideos();
    callbackModals();
    autoCloseModal();
    resizes();
    swiperMM();
    swiperWe();
    // headerScrollToBlock();
    setSmokeWithStartBanner();
    setSmokeWithGarant();
    swiperReview();
    programSwiper();
    mobMenu();

    questionSecond();

    $(".main-form .form .close").on("click", function () {
        closeModal($(".main-form"));
    });

    wrapInputWaIcons();

    handleProgramExamples();
    hanldeReviewsSecond();

    handleRecieveGiftModalShow();
});

$(() => {
    const formSelectors = [
        "contact-form",
        "banner-contact-form",
        "why-contact-form",
        "wide-contact-form",
        "extended-form",
        "red-form__form",
        "consultation-form",
        "wide-form-second",
        "wide-form-three",
        "contact-form-header",
        "contact-form-request-call",
        "contact-form-bottom",
    ];

    import("../components/newFormsLoader").then(async ({ newFormsLoader }) => {
        const module = await newFormsLoader();
        const { newForms, newPhoneInput } = module;

        formSelectors.map(function (formSelector) {
            const $form = $(`#${formSelector}`);

            if (!$form.length) {
                return;
            }

            const redirectTo = $form.attr("data-redirect") || "/thanks/";
            let $formButton = $form.find(".btn");

            if (!$formButton.length) $formButton = $form.find("button");

            const $phone = $form.find(".input__phone");

            if ($phone.length) {
                newPhoneInput.phoneInput($phone);
            }

            let $tokenInput = $form.find('input[name="_token"]');

            if (!$tokenInput.length) {
                $tokenInput = $('<input type="hidden" name="_token" value="">');
                $form.append($tokenInput);

                fetch("/csrf-token")
                    .then((response) => {
                        if (!response.ok)
                            throw new Error("Network response was not ok");
                        return response.json();
                    })
                    .then((data) => {
                        $tokenInput.val(data.token);
                        console.log("CSRF Token synchronized.");
                    })
                    .catch((error) => {
                        console.error("Error fetching CSRF token:", error);
                    });
            }

            console.log($tokenInput);

            $formButton.on("click", function (e) {
                e.preventDefault();

                newForms.defaultFormHandle(e, {
                    done: (dataFromServer) => {
                        dataFromServer = dataFromServer || {};
                        redirectToThanksPage(
                            dataFromServer.redirectTo || redirectTo,
                        );
                    },
                    showSuccessModal: false,
                });
            });
        });
    });
});

/**
 * Позиционирование плавающих кнопок
 */
const handleStickyButtons = () => {
    const $buttonsWrapper = $(".sticky-buttons .sticky-buttons__wrapper");

    if (!$buttonsWrapper.length) {
        return;
    }

    const $requestButtonWrapper = $(".receive-gift-button__wrapper");

    if ($requestButtonWrapper.length) {
        const $buttons = $buttonsWrapper.find("a");

        // Проверяем, что кнопки ещё не перенесены
        if (
            $buttons.length &&
            !$buttons.closest(".receive-gift-button__wrapper").length
        ) {
            $requestButtonWrapper.prepend($buttons);
        }

        return;
    }

    const windowWidth = $(window).width();
    const pageWidth = $(
        ".section__start-banner .container, .main-content .container",
    ).outerWidth();
    const paddingToContent = (windowWidth - pageWidth) / 2;
    const jivoWidth = 350 + 450;

    if (paddingToContent < jivoWidth) {
        const diff = jivoWidth - paddingToContent;
        $buttonsWrapper.css({ paddingRight: `${diff}px` });
    }
};

const resizes = () => {
    countryBlueResize();
    movedTel();
    campPayedMove();
    handleStickyButtons();
};

window.addEventListener("resize", function () {
    resizes();
});

const studiedSwiper = () => {
    const studiedSwiperDiv = $(".studied__swiper");

    if (!studiedSwiperDiv.length) {
        console.warn("There is no studied swiper div");
        return;
    }

    const swiper = new Swiper(".studied__swiper", {
        slidesPerView: 1,
        allowTouchMove: true,
        spaceBetween: 30,
        autoHeight: true,
    });

    const names = $(".section__studied .item__names");
    const swiperNames = new Swiper(names[0], {
        slidesPerView: 4,
        initialSlide: 4,
        spaceBetween: 10,
        centeredSlides: true,
        // allowTouchMove: false,
    });

    swiper.slideTo(0);
    swiperNames.slideTo(0);

    swiperNames.on("slideChange", function () {
        swiper.slideTo(swiperNames.realIndex);
    });

    swiper.on("slideChange", function () {
        swiperNames.slideTo(swiper.realIndex);
    });

    $(".section__studied .item__names li").map((index, item) => {
        $(item).on("click", function () {
            $(swiperNames).removeClass("active");
            swiper.slideTo(index);
            swiperNames.slideTo(index);
        });
    });
};

const studiedSwiper2 = () => {
    const $containers = $(".section__studied");

    if (!$containers.length) {
        console.warn("There is no studied section");
        return;
    }

    $containers.each(function () {
        const $container = $(this);

        const $mainSwiperContainer = $container.find(".studied__swiper");

        if (!$mainSwiperContainer.length) {
            return;
        }

        const mainSwiper = new Swiper($mainSwiperContainer[0], {
            slidesPerView: 1,
            allowTouchMove: true,
            spaceBetween: 30,
            autoHeight: true,
        });

        mainSwiper.slideTo(0);

        const $namesSwiperItems = $container.find(".item__names li");

        if (!$namesSwiperItems.length) {
            return;
        }

        const $scrollContainer = $container.find(".item__names");

        const updateNamesSwiperActiveClass = (index) => {
            $namesSwiperItems.removeClass("swiper-slide-active");
            const $activeName = $namesSwiperItems
                .eq(index)
                .addClass("swiper-slide-active");

            // 1. Ширина видимой части контейнера
            const containerWidth = $scrollContainer.width();

            // 2. Позиция активного элемента слева относительно контейнера
            const itemLeft = $activeName.position().left;

            // 3. Ширина самого активного элемента
            const itemWidth = $activeName.outerWidth();

            // 4. Текущая позиция скролла контейнера
            const currentScrollLeft = $scrollContainer.scrollLeft();

            // 5. Вычисляем новую позицию скролла, чтобы элемент был по центру
            const newScrollLeft =
                currentScrollLeft +
                itemLeft -
                containerWidth / 2 +
                itemWidth / 2;

            // 6. Плавно анимируем скролл к вычисленной позиции
            $scrollContainer.stop().animate(
                {
                    scrollLeft: newScrollLeft,
                },
                0,
            );
        };

        mainSwiper.on("slideChange", function () {
            updateNamesSwiperActiveClass(mainSwiper.realIndex);
        });

        updateNamesSwiperActiveClass(mainSwiper.realIndex);

        $namesSwiperItems.on("click", function () {
            const $clickedNameItem = $(this);
            const clickedIndex = $clickedNameItem.index();

            updateNamesSwiperActiveClass(clickedIndex);
            mainSwiper.slideTo(clickedIndex);
        });
    });
};

const callbackModals = () => {
    // Вешаем на эти селекторы открытие модалки
    const selectors = [
        ".header__btn",
        ".review__body .review__btn .btn",
        ".company .col__info-btn .btn",
        ".section__program .btn",
        ".section__plus .btn",
        ".request-callback-button",

        // общий класс - действие открытие модалки на кнопку
        ".act--open-modal-button",
    ];

    $(selectors.join(", ")).on("click", () => {
        showMainModal();
    });

    // // Тут у модалки чуть сложнее, меняется заголовок и выбирается страна
    // $(".section__country-blue .body__flag .btn").on("click", function () {
    //     const selectedCountryName = $(this).closest('.body__flag').find('.body__flag-text').text().trim();

    // 	showMainModal(
    // 		"Получить информацию",
    //         selectedCountryName,
    // 	);
    // });

    // По новому ТЗ в модальном окне должен находиться свапер с картинками
    $(
        ".section__country-blue .body__flag .btn, .section__country-blue .body__flag .body__flag-text",
    ).on("click", function () {
        const modalData = $(this).closest(".body__flag").find(".modal-content");

        if (!modalData.length) {
            console.warn("There is no modal data");
            return;
        }

        const modalContent = modalData.clone();
        const swiperDiv = modalContent.find(".swiper");

        new Swiper(swiperDiv[0], {
            modules: [Pagination, Navigation],
            slidesPerView: 1,
            autoHeight: true,

            pagination: {
                el: ".swiper-pagination",
            },

            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

        modalContent.modal();

        modalContent.on("modal:close", function () {
            modalContent.remove();
        });
    });
};

const showMainModal = (textTitle = null, country = null) => {
    // Проставляем страну, если выбрано и убираем, если нет
    if (country != null) {
        $("#input-country").val(country);
    } else {
        $("#input-country").val("");
    }

    textTitle = textTitle || "Заказать звонок";

    $(".mask").show();

    $("html").css({
        overflow: "hidden",
    });

    $(".custom-modal").find(".form__title").text(textTitle);

    $(".custom-modal").show();
};

const showReceiveGiftModal = () => {
    $(".mask").show();
    $("html").css({
        overflow: "hidden",
    });
    $(".receive-gift-modal").show();
};

const autoCloseModal = () => {
    $(document).on("mouseup keyup", function (e) {
        if (e.type == "keyup" && e.key !== "Escape") {
            return;
        }

        let div = "";

        // if custom modal (standart form) is open - define this modal as div
        if ($(".custom-modal").css("display") !== "none") {
            div = $(".custom-modal");
        }

        // if receive gift is open - define this modal as div
        if ($(".receive-gift-modal").css("display") !== "none") {
            div = $(".receive-gift-modal");
        }

        // start close modal function if modal window if it open
        if (div.length && div.css("display") !== "none") {
            if (!div.is(e.target) && div.has(e.target).length === 0) {
                closeModal(div);
            }
        }
    });
};

const closeModal = (div) => {
    $(".mask").hide();
    $("html").css({
        overflow: "auto",
    });

    const modal = div;
    // remove error divs
    modal.find(".form-error").remove();
    modal.find(".form__error").remove();
    // hide modal
    modal.hide();
};

const reviewSwiper = () => {
    const swiper = new Swiper(".review__swiper", {
        slidesPerView: 1,
        allowTouchMove: false,
        autoHeight: true,
    });

    const namesCount = $(".review__users .review__user").length;

    $(".section__review .review__user").map((index, item) => {
        const count = index % namesCount;
        $(item).on("click", function () {
            swiper.slideTo(count);
            $(".review__user").removeClass("active");
            $(item).addClass("active");
        });
    });
};

const questionBlocks = () => {
    $(".item__main").map((index, item) => {
        $(item).on("click", function () {
            if ($(item).hasClass("active")) {
                $(item).find(".plus").show();
                $(item).find(".minus").hide();
                $(item).removeClass("active");

                $(item).parent().find(".item__elements").removeClass("show");
                $(item).parent().find(".item__elements").css({
                    position: "absolute",
                });
            } else {
                $(item).find(".minus").show();
                $(item).find(".plus").hide();
                $(item).addClass("active");

                $(item).parent().find(".item__elements").addClass("show");
                $(item).parent().find(".item__elements").css({
                    position: "relative",
                });
            }
        });
    });
};

const questionBlocksSecond = () => {
    $(".item__second").map((index, item) => {
        $(item).on("click", function () {
            if ($(item).hasClass("active")) {
                $(item).find(".plus").show();
                $(item).find(".minus").hide();
                $(item).removeClass("active");

                $(item).parent().find(".item__text").fadeOut(0);
            } else {
                $(item).find(".minus").show();
                $(item).find(".plus").hide();
                $(item).addClass("active");

                $(item).parent().find(".item__text").fadeIn(1000);
            }
        });
    });
};

const questionSecond = () => {
    $(".question-second__question").map((index, item) => {
        $(item).on("click", function () {
            const answer = $(item).parent().find(".question-second__answer");
            if ($(item).hasClass("active")) {
                $(item).removeClass("active");

                answer.fadeOut(0);
            } else {
                $(item).addClass("active");
                answer.fadeIn(1000);
            }
        });
    });
};

const showVideos = () => {
    $(".video-yt").each((index, item) => {
        $(item).on("click", function () {
            const videoCode = $(item).data("video");
            const videoLink = `https://www.youtube.com/embed/${videoCode}`;
            const modalContent = $("<iframe>", {
                width: "100%",
                height: "240",
                src: videoLink,
            });

            someModal(modalContent[0]);
        });
    });

    $(".video-rutube").each((index, item) => {
        $(item).on("click", function () {
            const videoCode = $(item).data("video");
            const videoLink = `https://rutube.ru/play/embed/${videoCode}`;
            const modalContent = $("<iframe>", {
                width: "100%",
                height: "240",
                frameBoder: 0,
                allow: "clipboard-write; autoplay",
                webkitAllowFullScreen: true,
                mozallowfullscreen: true,
                allowFullScreen: true,
                src: videoLink,
            });
            someModal(modalContent[0]);
        });
    });
};

const someModal = (content) => {
    const modal = document.createElement("div");
    modal.className = "modal";
    modal.append(content);

    $(modal).modal();

    $(() => {
        $(document).mouseup(function (e) {
            if (!$(modal).is(e.target) && $(modal).has(e.target).length === 0) {
                $(modal).remove();
            }
        });
    });
};

const countryBlueResize = () => {
    const width = window.innerWidth;
    const movedText = $(".section__country-blue .body__text");
    const mainFlags = $(".section__country-blue .body__flags");
    const miniFlags = $(".section__country-blue .images__flags");

    if (width < HG_MAX) {
        $(mainFlags).last().after($(movedText));
        $(movedText).last().after($(miniFlags));
    } else {
        $(".section__country-blue .body__col--2").prepend(movedText);
        $(".section__country-blue .images__col--2").prepend(miniFlags);
    }

    // if (width < XS_MAX) {
    //     $(".section__country-blue .form__gift p").text(
    //         "Подарим список популярных специальностей за рубежом"
    //     );
    // } else {
    //     $(".section__country-blue .form__gift p").text(
    //         "Дарим в подарок список лучших лагерей 2024"
    //     );
    // }
};

const swiperMM = () => {
    const swiper = new Swiper(".mm__swiper", {
        slidesPerView: 1.4,
        spaceBetween: 10,
        breakpoints: {
            700: {
                slidesPerView: 2.1,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 3,
            },
        },
    });

    const swiperPrev = $(".mm__btn-left");
    const swiperNext = $(".mm__btn-right");

    swiperHelper(swiper, swiperNext, swiperPrev);
};

const swiperWe = () => {
    const swiper = new Swiper(".we__swiper", {
        slidesPerView: 1.7,
        spaceBetween: 10,
        breakpoints: {
            400: {
                slidesPerView: 2,
            },
            700: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 4,
            },
        },
    });
    const swiperPrev = $(".we__btn-left");
    const swiperNext = $(".we__btn-right");

    swiperHelper(swiper, swiperNext, swiperPrev);
};

const swiperHelper = (swiper, btnNext, btnPrev) => {
    if (!swiper.allowSlideNext) {
        $(btnNext).css({
            opacity: 0.2,
        });
    }

    swiper.on("slideChange", function (e) {
        if (!swiper.isBeginning) {
            $(btnPrev).css({
                opacity: 1,
            });
        } else {
            $(btnPrev).css({
                opacity: 0.2,
            });
        }

        if (!swiper.isEnd) {
            $(btnNext).css({
                opacity: 1,
            });
        } else {
            $(btnNext).css({
                opacity: 0.2,
            });
        }
    });

    if (btnPrev) {
        $(btnPrev).on("click", () => {
            swiper.slidePrev();
        });
    }

    if (btnNext) {
        $(btnNext).on("click", () => {
            swiper.slideNext();
        });
    }
};

const movedTel = () => {
    const width = window.innerWidth;

    if (width < SM_MAX) {
        $(".tel__friend").prepend($(".tel__friend .friend__phones"));
    }
};

const setSmokeWithStartBanner = () => {
    const smokeBlocks = $(".start-banner").find(".smoke");
    $(smokeBlocks).map((index, item) => {
        if (index === 0) {
            $(item).css({
                background: `linear-gradient(360deg,rgba(65, 86, 90, 0) 0%,#${$(
                    item,
                ).data("hex")} 71.87%)`,
            });
        } else {
            $(item).css({
                background: `linear-gradient(0, #${$(item).data(
                    "hex",
                )} 11.13%, rgba(117, 161, 44, 0.00) 59.35%)`,
            });
        }
    });
};

const setSmokeWithGarant = () => {
    const smokeBlocks = $(".garant").find(".smoke");
    $(smokeBlocks).map((index, item) => {
        $(item).css({
            background: `linear-gradient(180deg, #${$(item).data(
                "hex",
            )} 0.06%, rgba(31, 63, 107, 0) 58.77%)`,
        });
    });
};

const swiperReview = () => {
    const swiper = new Swiper(".review__video--photo", {
        slidesPerView: 1,
        spaceBetween: 50,
        grabCursor: true,
        modules: [Navigation, Pagination],

        pagination: {
            el: ".swiper-pagination",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
};

const programSwiper = () => {
    const swiper = new Swiper(".program__swiper", {
        slidesPerView: 1.4,
        spaceBetween: 10,
        grabCursor: true,
        modules: [Navigation],
        breakpoints: {
            400: {
                slidesPerView: 1.9,
            },
            430: {
                slidesPerView: 2.2,
            },
            600: {
                slidesPerView: 2.4,
            },
            800: {
                slidesPerView: 2.8,
            },
            992: {
                slidesPerView: 3.5,
            },
            1200: {
                slidesPerView: 4.3,
            },
            1440: {
                slidesPerView: 5.1,
            },
        },
        navigation: {
            nextEl: ".program__btn-right",
            prevEl: ".program__btn-left",
        },
    });

    const swiperPrev = $(".program__btn-left");
    const swiperNext = $(".program__btn-right");

    swiperHelper(swiper, swiperNext, swiperPrev);
};

const mobMenu = () => {
    const $mobileMenu = $(".mob-menu");
    const $mobileMenuContent = $(".mob-menu__content");

    // Строим меню один раз
    const buildMenu = () => {
        $mobileMenuContent.html("");

        let $links = $(".header__links");

        if ($links.length > 0) {
            $links = $links.clone();

            // Ищем ссылку, текст которой совпадает с "Контакты"
            const hasContacts =
                $links.find("a").filter(function () {
                    return $(this).text().trim().toLowerCase() === "контакты";
                }).length > 0;

            if (!hasContacts) {
                $links.append(
                    "<li class='header__link'><a href='#contacts'>Контакты</a></li>",
                );
            }
        } else {
            $links = $("<ul>").addClass("header__links");
        }

        $mobileMenuContent.append($links);

        $(".section__mobile-buttons .buttons:first a")
            .clone()
            .removeAttr("class")
            .each(function () {
                $("<li>")
                    .addClass("header__link highlighted")
                    .append($(this))
                    .appendTo($mobileMenuContent.find(".header__links"));
            });

        // Перенос выделенных кнопок вниз (например "Грант в школе Италии")
        $mobileMenuContent
            .find(".header__link .btn--highlighted")
            .each(function () {
                $(this)
                    .parent()
                    .appendTo($mobileMenuContent.find(".header__links"));
            });
    };

    buildMenu();

    // Закрытие — делегирование на статичный родитель
    $mobileMenu.on("click", ".header__links, a", () => {
        $mobileMenu.hide("fast");
    });

    $(".mob-menu__top svg").on("click", () => {
        $mobileMenu.hide("fast");
    });

    $(".burger").on("click", () => {
        $mobileMenu.show("fast");
    });
};

$(() => {
    (function () {
        $(".dropbtn").each((index, item) => {
            $(item).on("click", function () {
                $(".dropdown-content").each((index, item) => {
                    item.classList.remove("show");
                });

                const id = $(item).data("drop");
                $(`#myDropdown${id}`).toggleClass("show");
            });
        });
    })();
});

// Close the dropdown menu if the user clicks outside of it
window.onclick = function (event) {
    if (!event.target.matches(".dropbtn")) {
        const dropdowns = $(".dropdown-content");

        $(dropdowns).each((index, item) => {
            if (item.classList.contains("show")) {
                item.classList.remove("show");
            } else {
            }
        });
    }
};

const campPayedMove = () => {
    const width = window.innerWidth;

    if (width > SM_MAX) {
        $(".tel__main .main__container").append($(".main__email"));
    } else {
        $(".friends__title").before($(".main__email"));
    }

    if (width < LG_MAX) {
        $(".footer .container").append($(".friend__phones .friend__payed"));
    } else {
        $(".friend__phones").append($(".friend__payed"));
    }
};

// const handleAboutScholarship = () => {
//     const container = $("div[data-block-type='edu1-about-scholarship']");
//     const modalForm = $(".about-scholarship-modal");

//     if (!container.length || !modalForm.length) {
//         return false;
//     }

//     container.find("input[type=checkbox]").each(function () {
//         const checkbox = $(this);
//         checkbox.on("click", function () {
//             const isChecked = checkbox.prop("checked");
//         });
//     });
// };

// const showAboutScholarshipModal = (element) => {
//     $(element).on("click", function () {
//         $(".mask").show();
//         $("html").css({
//             overflow: "hidden",
//         });
//         $(".about-scholarship-modal").show();
//     });
// };

// $('.section-success .dot').on('click', function () {

//     $(this).toggleClass('active');

//     // click outside
//     $(document).on('click', function (e) {
//         if (!$(this).closest('.dot').length) {
//             $('.section-success .dot').removeClass('active');
//         }
//     });

// })

// Инициализация Popper.js для точек
const initSuccessDots = () => {
    const dots = document.querySelectorAll(".section-success .dot");

    dots.forEach((dot) => {
        const popup = dot.querySelector(".dot__popup");
        if (!popup) return;

        // Создаем экземпляр Popper
        const popperInstance = createPopper(dot, popup, {
            placement: "top",
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [0, 8],
                    },
                },
            ],
        });

        // Обработчик клика по точке
        dot.addEventListener("click", (e) => {
            e.stopPropagation();

            const isActive = dot.classList.contains("active");

            // Закрываем все остальные попапы
            dots.forEach((otherDot) => {
                if (otherDot !== dot) {
                    otherDot.classList.remove("active");
                }
            });

            // Переключаем состояние текущего попапа
            dot.classList.toggle("active");

            // Обновляем позицию Popper
            if (dot.classList.contains("active")) {
                popperInstance.update();
            }
        });
    });

    // Обработчик клика вне точек
    document.addEventListener("click", (e) => {
        if (!e.target.closest(".section-success .dot")) {
            dots.forEach((dot) => {
                dot.classList.remove("active");
            });
        }
    });
};

// Вызываем инициализацию после загрузки DOM
document.addEventListener("DOMContentLoaded", initSuccessDots);

// Функция для корректировки прокрутки страницы при клике на якорные ссылки
const adjustScrollForFixedHeader = () => {
    // Получаем все ссылки, начинающиеся с #
    const anchorLinks = document.querySelectorAll('a[href^="#"]');

    // Функция для получения высоты хедера
    const getHeaderHeight = () => {
        const header = document.querySelector(".header-second");
        return header ? header.offsetHeight : 0;
    };

    // Обработчик клика по якорным ссылкам
    anchorLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
            // Получаем целевой элемент по id из href
            const targetId = this.getAttribute("href");
            if (targetId === "#") return; // Пропускаем пустые якоря

            const targetElement = document.querySelector(targetId);
            if (!targetElement) return; // Если элемент не найден, прерываем

            e.preventDefault(); // Предотвращаем стандартное поведение

            // Получаем текущую высоту хедера
            const headerHeight = getHeaderHeight();

            // Вычисляем позицию для прокрутки с учетом высоты хедера
            const targetPosition =
                targetElement.getBoundingClientRect().top +
                window.pageYOffset -
                headerHeight;

            // Плавно прокручиваем страницу
            window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
            });
        });
    });

    // Обработчик изменения размера окна для обновления высоты хедера
    window.addEventListener("resize", () => {
        // Обновляем обработчики при изменении размера окна
        // Это необходимо, так как высота хедера может измениться
        anchorLinks.forEach((link) => {
            // Удаляем старый обработчик
            link.removeEventListener("click", link.clickHandler);

            // Создаем новый обработчик
            link.clickHandler = function (e) {
                const targetId = this.getAttribute("href");
                if (targetId === "#") return;

                const targetElement = document.querySelector(targetId);
                if (!targetElement) return;

                e.preventDefault();

                const headerHeight = getHeaderHeight();
                const targetPosition =
                    targetElement.getBoundingClientRect().top +
                    window.scrollY -
                    headerHeight;

                window.scrollTo({
                    top: targetPosition,
                    behavior: "smooth",
                });
            };

            // Добавляем новый обработчик
            link.addEventListener("click", link.clickHandler);
        });
    });
};

// Вызываем функцию после загрузки DOM
document.addEventListener("DOMContentLoaded", adjustScrollForFixedHeader);

$(document).ready(function () {
    // Функция для анимации процента от 0 до целевого значения
    function animatePercentage(targetValue) {
        let startTime = null;
        const duration = 2000; // 2 секунды

        function easeOut(t) {
            return 1 - Math.pow(1 - t, 3); // Кубическая функция ease-out
        }

        function updatePercentage(timestamp) {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / duration, 1);
            const easedProgress = easeOut(progress);

            const currentValue = Math.floor(easedProgress * targetValue);
            $(".circle-progress__percentage").text(currentValue + "%");

            if (progress < 1) {
                requestAnimationFrame(updatePercentage);
            }
        }

        requestAnimationFrame(updatePercentage);
    }

    // Создаем Intersection Observer для отслеживания видимости элемента
    const percentageElement = document.querySelector(
        ".circle-progress__percentage",
    );
    let animationStarted = false;

    if (percentageElement) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    // Если элемент виден и анимация еще не запускалась
                    if (entry.isIntersecting && !animationStarted) {
                        animationStarted = true;

                        // Получаем текущее значение процента и запускаем анимацию
                        const targetPercentage = parseInt(
                            $(".circle-progress__percentage").attr(
                                "data-percentage",
                            ),
                        );
                        $(".circle-progress__percentage").text("0%");
                        animatePercentage(targetPercentage);

                        // Отключаем observer после запуска анимации
                        // observer.disconnect();
                        animationStarted = false;
                    }
                });
            },
            {
                threshold: 0.5, // Запускаем, когда 50% элемента видно
            },
        );

        // Начинаем наблюдение за элементом
        observer.observe(percentageElement);
    }
});

// $(() => {
//     const canvas = document.getElementById('tractorCanvas');
//     canvas.width = 300;
//     canvas.height = 300;
//     canvas.style.width = '300px';
//     canvas.style.height = '300px';
//     const ctx = canvas.getContext('2d');
//     let smokeParticles = [];

//     let start = 0;

//     const img = new Image();
//     img.src = '/images/edu1/tractor.svg'; // Can also be a data URI or Blob URL

//     function drawTractor() {
//         // Тело трактора
//         ctx.fillStyle = '#555';
//         ctx.fillRect(120, 180, 160, 60); // основное тело
//         ctx.fillStyle = '#4caf50';
//         ctx.fillRect(200, 140, 60, 40); // кабина
//         // Колёса
//         ctx.beginPath();
//         ctx.arc(130, 250, 30, 0, 2 * Math.PI);
//         ctx.fillStyle = '#333';
//         ctx.fill();
//         ctx.beginPath();
//         ctx.arc(270, 250, 20, 0, 2 * Math.PI);
//         ctx.fillStyle = '#333';
//         ctx.fill();
//         // Труба
//         ctx.fillStyle = '#555';
//         ctx.fillRect(240, 120, 10, 30);
//     }

//     function drawSmoke() {
//         for (let i = 0; i < smokeParticles.length; i++) {
//             let p = smokeParticles[i];
//             ctx.globalAlpha = p.alpha;
//             ctx.beginPath();
//             ctx.arc(p.x, p.y, p.size, 0, 2 * Math.PI);
//             ctx.fillStyle = '#fff';
//             ctx.fill();
//             ctx.globalAlpha = 1.0;
//             // Обновление позиции и прозрачности
//             p.x += p.vx;
//             p.y += p.vy;
//             p.alpha -= 0.01;
//             p.size += 0.05;
//         }
//         // Удаляем исчезнувшие частицы
//         smokeParticles = smokeParticles.filter(p => p.alpha > 0);
//     }

//     function addSmoke(start) {
//         // Координаты трубы
//         let x = start + 80;
//         let y = 150;
//         smokeParticles.push({
//             x: x,
//             y: y,
//             vx: Math.random() * 0.5 - 0.25,
//             vy: -1.2 - Math.random() * 0.5,
//             alpha: 0.7 + Math.random() * 0.3,
//             size: 8 + Math.random() * 4
//         });
//     }

//     let it = 2000;

//     function animate() {

//         start = Math.sin(it / 100) * 100;

//         ctx.clearRect(start, 0, canvas.width, canvas.height);
//         // drawTractor();
//         drawSmoke(start);
//         ctx.drawImage(img, start, 150);

//         if (Math.random() < 0.5) addSmoke(start);

//         requestAnimationFrame(animate);

//         it += 0.5;

//     }

//     img.onload = function () {
//         animate();
//     };
// })

/**
 * Определяем страну и показываем соответствующий блок
 */
$(() => {
    $.get("https://smapse.com/geo-city/", {}, function (data) {
        $("[data-geo-show]").hide();
        $('[data-geo-show="' + data.countryCode + '"]').show();
    });
});

/**
 * Так как иконка ватсапп в инпуте номера телефона добавляется с некоторой задержкой
 * для оборачивания этой иконки в класс с необходимыми для этого лендинга свойствами
 * не опираясь на таймаут появления иконки реализовать функционал
 */
const wrapInputWaIcons = () => {
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (
                mutation.type === "childList" &&
                mutation.addedNodes.length > 0
            ) {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType === 1) {
                        const svgs = node.querySelectorAll("svg");

                        svgs.forEach(function (svg) {
                            const parentDiv = svg.parentNode;

                            if (
                                parentDiv &&
                                parentDiv.nodeName.toLowerCase() === "div" &&
                                wrapWhatsappIcon
                            ) {
                                // Проверка находится ли данный svg иконки внутри формы
                                const isInsideForm = Boolean(
                                    parentDiv.closest("form") ||
                                    parentDiv.closest(".form"),
                                );

                                // Если вне формы, то ничего не происходит
                                if (!isInsideForm) {
                                    return;
                                }

                                // Добавляем класс
                                parentDiv.classList.add("wa-phone-icon");
                                // Для плавного появления устанавливается непрозрачость
                                parentDiv.style.opacity = 0;

                                // и потом необходимо ее убрать
                                setTimeout(() => {
                                    parentDiv.style.removeProperty("opacity");
                                }, 10);
                            }
                        });
                    }
                });
            }
        });
    });

    // Конфиг для проверки дерева элементов
    const config = {
        childList: true,
        subtree: true,
    };

    // Обозреваем тело документа
    observer.observe(document.body, config);
};

const handleProgramExamples = () => {
    const $containers = $(".program-examples");

    if (!$containers.length) {
        return;
    }

    $containers.each(function () {
        const $this = $(this);

        const $groupNames = $this.find(".program-examples__group-name");
        const $groupItems = $this.find(".program-examples__items");

        if (!$groupNames.length || !$groupItems.length) {
            return;
        }
        if (!$groupNames.hasClass("active")) {
            const $firstItem = $groupNames.first();
            $firstItem.addClass("active");

            const $firstItemLabel = $firstItem.data("label");
            $groupItems
                .filter(`[data-group="${$firstItemLabel}"]`)
                .addClass("show");
        }

        $groupNames.on("click", function () {
            const $clickedGroupName = $(this);
            const clickedLabel = $clickedGroupName.data("label");

            $groupNames.removeClass("active");
            $groupItems.removeClass("show");

            $clickedGroupName.addClass("active");

            if (clickedLabel) {
                $groupItems
                    .filter(`[data-group="${clickedLabel}"]`)
                    .addClass("show");
            }
        });
    });
};

const hanldeReviewsSecond = () => {
    const $containers = $(".section__reviews-second");

    if (!$containers.length) {
        return;
    }

    $containers.each(function () {
        const $container = $(this);
        const $swiperContainer = $container.find(".swiper");

        if (!$swiperContainer.length) {
            return;
        }

        const swiper = new Swiper($swiperContainer[0], {
            slidesPerView: 1,
            allowTouchMove: false,
            autoHeight: true,
        });

        const $sideItems = $container.find(".review__side-item");

        $sideItems.first().addClass("active");

        $sideItems.on("click", function (index) {
            $sideItems.removeClass("active");

            const $clickedSideItem = $(this);
            const clickedIndex = $clickedSideItem.index();

            $clickedSideItem.addClass("active");
            swiper.slideTo(clickedIndex);
        });
    });
};

const handleRecieveGiftModalShow = () => {
    $(".btn.receive-gift-button").on("click", function () {
        showReceiveGiftModal();
    });
};
